<!-- 中奖记录 -->
<template>
  <div class="log-container">
    <top></top>
    <van-list v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList" class="log-wrapper">
      <div class="log-item" v-for="item in list" :key="item.id" @click="toDetail(item)">
        <div class="left">
          <p>抽奖获得 <span>{{item.product.name}}</span></p>
          <span>{{item.created | timeParse}}</span>
        </div>
        <div class="right">{{item.status | statusFilter}}</div>
      </div>
    </van-list>
    <div v-else class="blank-content">
      <p class="blank-title">没找到中奖记录</p>
      <p class="blank-desc">亲爱的用户您没有任何中奖记录</p>
      <button @click="toIndex" class="blank-btn">去主页看看</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import top from '@/components/top'
import { List } from 'vant'
Vue.use(List)

export default {
  name: 'LotteryLog',
  components: { top },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      next: '/credit/lottery/log/?limit=10'
    }
  },
  mounted() {
  },
  filters: {
    timeParse(time) {
      const dateArr = time.split('T')
      const timeArr = dateArr[1].split('.')
      return dateArr[0] + ' ' + timeArr[0]
    },
    statusFilter(status) {
      const statusMap = {
        0: '待领取',
        1: '待发货',
        2: '已发货',
        3: '已完成'
      }
      return statusMap[status]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      var that = this
      this.axios.get(this.next).then(function(res) {
        console.log(res.data)
        that.list = that.list.concat(res.data.results)
        that.loading = false
        if (res.data.next) {
          that.next = res.data.next
        } else {
          that.finished = true
        }
      }).catch(function(error) {
        console.log(error)
      })
    },

    toDetail(item) {
      if (item.product.type === 2) {
        if (!item.status) {
          this.$router.push({ path: '/goods/exchange', query: { lotteryId: item.id }})
        } else {
          this.$router.push({ path: '/user/exchange/detail', query: { lotteryId: item.order }})
        }
      } else if (item.product.type === 3) {
        // this.$router.push()
        this.$router.go(-2)
        window.location.href = item.product.url
      } else {
        return
      }
    },

    /**
     * 去首页
     */
    toIndex() {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>

<style lang="scss" scoped>
.log-wrapper{
  margin-top: 60px;
  .log-item{
    width: 345px;
    height: 70px;
    padding: 0 15px;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto 1px;
    .left{
      height: 50px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      p{
        width: 210px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 400;
        span{
          color: #f5a623;
          font-size: 14px;
          font-weight: 600;
        }
      }
      span{
        color: #aaaaaa;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .right{
      color: #747474;
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/log.vue